import { FilterGroup, FilterGroupItem } from '../../interfaces/POSGroupFilter';

export const SELECT_ALL = 'select-all';

export const xdmContextDelimiter = '::';
export const filterGroups: FilterGroup[] = [
  { groupId: 'client', groupName: 'Clients' },
  { groupId: 'brand', groupName: 'Brand' },
  { groupId: 'product', groupName: 'Product' },
];

const getFilterGroupItems = () => {
  const parentItems: FilterGroupItem[] = [];
  const childItems: FilterGroupItem[] = [];

  filterGroups.forEach((group) => {
    for (let i = 1; i <= 10; i++) {
      parentItems.push({
        itemId: `${group.groupId}Item${i}`,
        itemName: `${group.groupName}-${i}`,
        groupId: group.groupId,
      });
    }
  });

  filterGroups.forEach((group) => {
    const parentsByGroup = parentItems.filter(
      (p) => p.groupId === group.groupId
    );
    parentsByGroup.forEach((parent, parentIndex) => {
      for (let i = 1; i <= 12; i++) {
        if (parentIndex < 3) {
          childItems?.push({
            itemId: `${parent.itemId}SubItem${i}`,
            itemName: `${parent.itemName}-SubItem${i}`,
            groupId: parent.groupId,
            parentId: parent.itemId,
            subCategory: {
              subCategoryId: i <= 6 ? `subCategory1` : `subCategory2`,
              subCategoryName: i <= 6 ? `SubCategory1` : `SubCategory2`,
            },
          });
        }
      }
    });
  });

  return [...parentItems, ...childItems];
};

export const filterItems: FilterGroupItem[] = getFilterGroupItems();
